var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "rbacUploadJson", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "container-fluid row" }, [
              _vm._m(1),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("div", { staticClass: "upload-demo" }, [
                  _c("input", {
                    ref: "file",
                    attrs: {
                      type: "file",
                      name: _vm.uploadFieldName,
                      id: "custom-file",
                    },
                    on: { change: _vm.filesChange },
                  }),
                  _vm._m(2),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-modal-footer cancel",
                staticStyle: { float: "left", background: "#fff" },
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.cancelPermissions },
              },
              [
                _c("i", { staticClass: "fa fa-times-circle" }),
                _vm._v(" No, cancel "),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-modal-footer",
                staticStyle: { float: "right" },
                attrs: {
                  type: "button",
                  disabled: Object.keys(_vm.roleList).length == 0,
                },
                on: { click: _vm.uploadFile },
              },
              [_vm._v("Next")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header modal-bgcolor" }, [
      _c("div", { staticClass: "modal-title" }, [_vm._v("Upload JSON file")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-4 attachment-text" }, [
      _c("span", { staticClass: "cursor" }, [_vm._v(" Upload File:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "custom-file" } }, [
      _c("div", { staticClass: "cursor-pointer" }, [
        _c("a", { staticClass: "btn emergo-white-button" }, [
          _vm._v("Click to upload"),
        ]),
        _c("div", { staticClass: "notify_message" }, [
          _vm._v(" File type allowed: json "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }